
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ZDSC',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ZDSC.vue